<template>
  <component :is="layout" v-if="product">
    <template v-slot:default>
      <div class="structured-top">
        <h1 v-mark-word v-html="showSecondaryInfo ? product.titleSecond : (showShareInfo ? product.titleShare : product.title)" />
        <span class="report-alert" v-if="product.alert">{{ product.alert }}</span>

        <span class="lead" v-if="product.shortDescription" v-html="showSecondaryInfo ? product.shortDescriptionSecond : (showShareInfo ? product.shortDescriptionShare : product.shortDescription)" />

        <div class="content-accordion" v-if="product.contentDescription && !showShareInfo">
          <div class="card">
            <div class="card-header" role="tab">
              <a href="#" @click.prevent class="accordion-title collapsed" v-b-toggle.details>
                <span class="icon-arrow-down32" /> <span class="icon-arrow-up32" />
                {{ $t('report.whatsInside') }}
              </a>
            </div>

            <BCollapse id="details" :visible="isDetailsVisible">
              <div class="card-body">
                <div v-html="showSecondaryInfo ? product.contentDescriptionSecond : product.contentDescription" class="with-content primary" />
              </div>
            </BCollapse>
          </div>
        </div>

        <slot name="top" />
      </div>
      <slot />
    </template>
    <template v-slot:sidebar>
      <div>
        <slot name="callToAction" />

        <div class="sidebar-bottom">
          <div class="sidebar-card-wrapper">
            <template v-if="product.relatedIds">
              <h3 class="text-start text-sm-center mb-4 mb-md-8">{{ $t('report.relatedReports') }}</h3>
              <RelatedReports :product="product" name="relatedReports" />
            </template>
          </div>
        </div>
      </div>
    </template>
  </component>
</template>

<script>
import LayoutWithSidebar from './LayoutWithSidebar';
import RelatedReports from './RelatedReports';
import Banner from './Banner';
import { BCollapse } from 'bootstrap-vue-next';

export default {
  props: {
    product: Object,
    layout: { type: Object, default: () => LayoutWithSidebar },
    isDetailsVisible: { type: Boolean, default: false },
    showSecondaryInfo: { type: Boolean, default: false },
    showShareInfo: { type: Boolean, default: false },
  },
  components: {
    BCollapse,
    RelatedReports,
    Banner,
  },
};
</script>
